module.exports = __webpack_public_path__ + "static/media/close.f4ff11bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/src/themes/fibrestream/assets/images/close.svg
// module id = 932
// module chunks = 0